import { IconButton } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import OrgTextField from "@material-ui/core/TextField";
import { Search } from "@material-ui/icons";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { makeStyles } from "@material-ui/styles";
import { FieldRenderProps } from "react-final-form";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: "0 10"
    },
    searchBar: {
      margin: "0 auto"
    },
    iconButton: {
      padding: 10
    }
  })
);

export interface SearchFieldProps extends FieldRenderProps<any> {
  error?: boolean;
  executeSearch: (text: string) => void;
  minNumberOfLetters: number;
  placeholder?: string;
}

export const SearchFieldComponent = observer((props: SearchFieldProps) => {
  const [text, setText] = useState("");
  const classes = useStyles();
  const { error, minNumberOfLetters, placeholder } = props;

  const handleKeySearch = (event: any) => {
    if (event.key === "Enter" && text.length >= props.minNumberOfLetters) {
      props.executeSearch(text);
    }
  };

  const handleChange = (event: any) => {
    setText(event.target.value);
  };

  const handleSearch = () => {
    props.executeSearch(text);
  };

  return (
    <div className={classes.root}>
      <OrgTextField
        placeholder={placeholder}
        onChange={handleChange}
        onKeyPress={handleKeySearch}
        value={text}
        variant="outlined"
        fullWidth={true}
        error={text.length < minNumberOfLetters || error}
        helperText={
          text.length < minNumberOfLetters
            ? `Input should be longer than ${minNumberOfLetters} characters`
            : ""
        }
        className={classes.searchBar}
        margin="dense"
        InputProps={{
          endAdornment: (
            <IconButton
              className={classes.iconButton}
              aria-label="search"
              onClick={handleSearch}
              disabled={text.length < minNumberOfLetters}
            >
              <Search />
            </IconButton>
          )
        }}
      />
    </div>
  );
});
